import React from 'react';
import { authRoles } from 'app/auth';

export const CoursesConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: [...authRoles.user, ...authRoles.instructor, ...authRoles.participant], //['admin', 'staff', 'user']
	routes: [
		{
			path: '/courses',
			component: React.lazy(() => import('./Courses'))
		},
		{
			// Self-paced viewer for org-private heidiai.io (Heidi LMS) courses,
			// opened from a workshop. Participants/instructors/admins (this config's
			// auth) can view; access is re-checked server-side per course.
			path: '/lms-courses/:slug',
			component: React.lazy(() => import('../heidi-lms/CourseViewer'))
		}
	]
};
